/* eslint-disable indent */
/* eslint-disable object-curly-newline */
import React from "react";
import { Modal, ModalHeader, ModalBody, Row, Col } from "reactstrap";
import { startCase } from "lodash";
import { useTranslation } from "react-i18next";
import {
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr
} from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { Link } from "react-router-dom";

export default function DetailsModal({ show, toggle, client }) {
  const { t } = useTranslation();
  if (!client) return null;


  const liveAcc = client.fx?.liveAcc || [];
  const demoAcc = client.fx?.demoAcc || [];

  return (
    <Modal isOpen={show} toggle={toggle}>
      <ModalHeader toggle={toggle}>Client Details</ModalHeader>
      <ModalBody>
        <Row className="mb-2">
          <Col xs={4}><strong>{t("Name")}:</strong></Col>
          <Col><Link to={`/clients/${client._id}/profile`}>{startCase(`${client.firstName} ${client.lastName}`)}</Link></Col>
        </Row>
        <Row className="mb-2">
          <Col xs={4}><strong>{t("Email")}:</strong></Col>
          <Col>{client.email}</Col>
        </Row>
        <Row className="mb-2">
          <Col xs={4}><strong>{t("Status")}:</strong></Col>
          <Col>{client.fx?.isIb ? t("Sub IB") : t("Client")}</Col>
        </Row>
        <Row className="mb-4">
          <Col xs={4}><strong>{t("Parent")}:</strong></Col>
          <Col>{client?.parent?.firstName} {client?.parent?.lastName}</Col>
        </Row>

        {/* Live Accounts */}
        <Row className="mb-4">
          <Col>
            <h5>{t("Live Accounts")}</h5>
            {liveAcc.length > 0 ? (
              <Table className="table table-hover text-center">
                <Thead>
                  <Tr>
                    <Th>{t("Account ID")}</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {liveAcc.map((account, index) => (
                    <Tr key={index}>
                      <Td>{account}</Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            ) : (
              <p className="text-muted">{t("No Live Accounts")}</p>
            )}
          </Col>
        </Row>

        {/* Demo Accounts */}
        <Row>
          <Col>
            <h5>{t("Demo Accounts")}</h5>
            {demoAcc.length > 0 ? (
              <Table className="table table-hover text-center">
                <Thead>
                  <Tr>
                    <Th>{t("Account ID")}</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {demoAcc.map((account, index) => (
                    <Tr key={index}>
                      <Td>{account}</Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            ) : (
              <p className="text-muted">{t("No Demo Accounts")}</p>
            )}
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
}
